import { Grid, Modal as ModalModule, UI } from 'common';
import isArray from 'lodash/isArray';
import uniqBy from 'lodash/uniqBy';
import React, { Component } from 'react';

import ContactsCommunication from '../utils/ContactsCommunication';
import NameCellRenderer from './NameCellRenderer.component';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;
const { WrappedInputText } = UI;
const { GridPanel } = Grid;

class MoveGroupModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			rowData: [],
			associate: [],
			disassociate: [],
			clean: true,
			columnDefs: [
				{
					field: 'name',
					flex: 1,
					checkboxSelection: false,
					cellRenderer: 'NameCellRenderer',
					cellRendererParams: ({ node, value }) => ({
						node,
						name: value,
						checkState: node.data.checkState,
						onSelectionChanged: this.onSelectionChanged,
					}),
				},
			],
		};

		this.gridApi = null;
	}

	componentDidMount() {
		this.getSelectedGroupNames();
	}

	getSelectedGroupNames = async () => {
		const {
			data: { selectedContacts },
		} = this.props;
		const { showError } = this.context;

		const contactIds = selectedContacts.map(contact => contact.ContactId);
		const response = await ContactsCommunication.getSelectedGroups(contactIds);

		if (ContactsCommunication.isSuccessful(response)) {
			const groupData = isArray(response.data.data) ? response.data.data : [];

			// builds array of selectedGroups based of the selectedContacts
			const selectedGroups = groupData.reduce((result, group) => {
				if (group.checkState === 1) {
					result.push(group);
				}
				return result;
			}, []);

			this.setState({
				rowData: groupData,
				associate: selectedGroups,
			});
		} else {
			showError({ response });
		}
	};

	onSelectionChanged = selection => {
		const { associate, disassociate } = this.state;

		this.setState({
			clean: false,
			associate:
				selection.checkState === 0
					? associate.filter(group => group.id !== selection.id)
					: uniqBy([selection, ...associate], 'id'),
			disassociate:
				selection.checkState === 0
					? uniqBy([selection, ...disassociate], 'id')
					: disassociate.filter(group => group.id !== selection.id),
		});
	};

	onPrimaryButtonClick = async () => {
		const { associate, disassociate } = this.state;
		const { closeModal, showError } = this.context;
		const {
			data: { selectedContacts, updateContactsState },
			modalId,
		} = this.props;

		const data = {
			associate: associate.map(group => group.id),
			disassociate: disassociate.map(group => group.id),
			newGroups: [],
		};

		if (selectedContacts.length === 1) {
			data.contactId = selectedContacts[0].ContactId;
			data.allSelected = false;
		} else {
			data.contacts = selectedContacts.map(contact => contact.ContactId);
			data.allSelected = true;
		}

		const response = await ContactsCommunication.groupAssociations(data);

		if (ContactsCommunication.isSuccessful(response)) {
			updateContactsState({
				refreshGroupUpdate: true,
			});
			closeModal(modalId, ModalButtonActionType.Ok);
		} else {
			showError({ response });
		}
	};

	onGridReady = ({ api }) => {
		this.gridApi = api;
	};

	onChangeSearch = ({ target: { value } }) => {
		this.gridApi.setQuickFilter(value);
	};

	render() {
		const { rowData, columnDefs, clean } = this.state;
		const { modalId } = this.props;

		const primaryButton = {
			type: ModalButtonActionType.Ok,
			onClick: this.onPrimaryButtonClick,
			disabled: clean,
			text: 'Save',
			dataqa: 'move-group-save-button',
		};

		return (
			<Modal
				modalId={modalId}
				className="contacts contacts-move-group-modal"
				header="Change Groups"
				primaryButton={primaryButton}
			>
				<div className="body p-grid p-dir-col">
					<p className="p-col-12">
						Choose which groups the selected contacts should belong to:
					</p>
					<div className="search p-col-12">
						<WrappedInputText
							className="ui-toolbar-search-input"
							name="searchBar"
							dataqa="searchbar"
							onChange={this.onChangeSearch}
							placeholder="Search"
						/>
						<span
							className="pi pi-search search-icon"
							tabIndex={0}
							role="button"
							aria-label="Search"
						/>
					</div>
					<div className="groups-list p-col-12">
						<GridPanel
							domLayout="autoHeight"
							dataqa="manage-groups-grid"
							rowData={rowData}
							showPagination={false}
							columnDefs={columnDefs}
							onGridReady={this.onGridReady}
							frameworkComponents={{ NameCellRenderer }}
						/>
					</div>
				</div>
			</Modal>
		);
	}
}

MoveGroupModal.contextType = ModalContext;

export default MoveGroupModal;
